var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuBackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 21.5C16.799 21.5 21.5 16.799 21.5 11C21.5 5.20101 16.799 0.5 11 0.5C5.20101 0.5 0.5 5.20101 0.5 11C0.5 16.799 5.20101 21.5 11 21.5ZM11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z",
    fill: "#19297C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.82843 14.5359L5.64645 11.3539C5.45118 11.1586 5.45118 10.842 5.64645 10.6468L8.82843 7.46481C9.02369 7.26954 9.34027 7.26954 9.53553 7.46481C9.7308 7.66007 9.7308 7.97665 9.53553 8.17191L7.20711 10.5003H17C17.2761 10.5003 17.5 10.7242 17.5 11.0003C17.5 11.2765 17.2761 11.5003 17 11.5003H7.20711L9.53553 13.8288C9.7308 14.024 9.7308 14.3406 9.53553 14.5359C9.34027 14.7311 9.02369 14.7311 8.82843 14.5359Z",
    fill: "#19297C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBackIcon);
export default __webpack_public_path__ + "static/media/menu-back-icon.550586a9f74975786405d0a2fd861252.svg";
export { ForwardRef as ReactComponent };